import React from 'react';

const ErrorPage = () => (<div>
  <h2>Ha ocurrido un problema</h2>
  <p>Por favor, verifica tu conexión a internet y refrescá y volvé a cargar la app.</p>
  <p>Si el problema persiste, contactate con nosotros.</p>
</div>);

export default ErrorPage;
